<template>
  <div>
    <el-dialog
      title="请手写签名"
      :visible.sync="dialogVisible"
      append-to-body
      width="50%"
      @closed="$emit('handleClosed')"
    >
      <transition name="fade">
        <sign
          v-if="dialogVisible"
          :currentImg="currentImg"
          @handleSaveSignature="handleSaveSignature"
          @handleDefault="handleDefault"
        />
      </transition>
    </el-dialog>
  </div>
</template>
<script>
import sign from './components/index'
export default {
  name: 'Signature',
  components: { sign },
  data() {
    return {
      dialogVisible: false,
      currentImg: undefined
    }
  },
  methods: {
    handleOpenSignature(img) {
      this.dialogVisible = true
      this.currentImg = img
    },
    handleSaveSignature(base64) {
      this.$emit('handleSaveSignature', base64)
      this.dialogVisible = false
    },
    handleDefault() {
      console.log('default')
      this.$emit('handleDefault')
      this.dialogVisible = false
    }
  }
}
</script>